import { createSelector } from "@reduxjs/toolkit";
import { AutomationConfig } from "./entity";
import { BaseState } from "./reducers";
import { SnackState } from "./snack";

export  const automations = createSelector((state: BaseState) => state.automations, (state: AutomationConfig[]) => state);
export  const drawlerSelector = createSelector((state: BaseState) => state.drawer.open, (state: boolean) => state);
export  const snackSelector = createSelector((state: BaseState) => state.snack, (state: SnackState) => state);